import { render, staticRenderFns } from "./TeacherGroupSchedulePurgeButton.vue?vue&type=template&id=66353324&scoped=true&"
import script from "./TeacherGroupSchedulePurgeButton.vue?vue&type=script&lang=js&"
export * from "./TeacherGroupSchedulePurgeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66353324",
  null
  
)

export default component.exports